import React from "react";
import { TeacherFeedbackResponse } from "../../api/teacherApi.ts";
import { ProfilePicture } from "../../components/profile/ProfilePicture.tsx";
import { format } from "date-fns";
import { useLanguageStore } from "../../stores/languageStore.ts";
import { Link } from "react-router";

interface TestimonialsProps {
  testimonials: TeacherFeedbackResponse[];
  maxDisplay?: number;
}

export const Testimonials: React.FC<TestimonialsProps> = ({
  testimonials,
  maxDisplay = 3,
}) => {
  const { dateFnsLocale } = useLanguageStore();
  const displayedTestimonials = testimonials.slice(0, maxDisplay);

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <div className="border-t-1 border-gray-200">
      <div className="mt-2 space-y-3">
        {displayedTestimonials.map((testimonial) => (
          <div key={testimonial.id} className="rounded-lg p-3">
            <Link
              to={`../${testimonial.userId}`}
              relative={"path"}
              className={"mb-2 flex items-center"}
            >
              <ProfilePicture
                className={"h-10 w-10"}
                profilePictureUrl={testimonial.profilePictureUrl}
                firstName={testimonial.name}
                lastName={""}
                iconSize={24}
              />
              <div>
                <p className="ml-2 text-sm font-medium">{testimonial.name}</p>
                <p className="ml-2 text-sm font-medium text-gray-500">
                  {format(testimonial.modifiedAt, "MMMM y", {
                    locale: dateFnsLocale,
                  })}
                </p>
              </div>
            </Link>
            <p className="text-gray-600 italic">"{testimonial.text}"</p>
          </div>
        ))}
      </div>
    </div>
  );
};
